import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Analytics } from "../types/analytics";
import { BASE_URL, envConfig } from "../config";

// Define a service using a base URL and expected endpoints
export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "analytics",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: [
    "Analytics",
    "FilteredTransactions",
    "FilteredStudents",
    "FilteredSubmissions",
    "FilteredTasks",
  ],
  endpoints: (builder) => ({
    getDashboard: builder.query<Analytics, string>({
      query: () => `/dashboard`,
      providesTags: ["Analytics"],
    }),
    getFilteredTransactions: builder.mutation<any, any>({
      query: ({ _id, ...filter }) => ({
        url: `/transactions`,
        method: "POST",
        body: filter,
      }),
      invalidatesTags: ["FilteredTransactions"],
    }),
    getFilteredStudents: builder.mutation<any, any>({
      query: ({ _id, ...filter }) => ({
        url: `/students`,
        method: "POST",
        body: filter,
      }),
      invalidatesTags: ["FilteredStudents"],
    }),
    getFilteredSubmissions: builder.mutation<any, any>({
      query: ({ _id, ...filter }) => ({
        url: `/submissions`,
        method: "POST",
        body: filter,
      }),
      invalidatesTags: ["FilteredSubmissions"],
    }),
    getFilteredTasks: builder.mutation<any, any>({
      query: ({ _id, ...filter }) => ({
        url: `/tasks`,
        method: "POST",
        body: filter,
      }),
      invalidatesTags: ["FilteredTasks"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDashboardQuery,
  useGetFilteredStudentsMutation,
  useGetFilteredSubmissionsMutation,
  useGetFilteredTransactionsMutation,
  useGetFilteredTasksMutation,
} = analyticsApi;
